export default function showOnInitiator() {

    let showons = document.querySelectorAll('.showon');
    for (let i=0; i<showons.length; i++) {
        let field = showons[i];

        let so = field.getAttribute('data-showon',null);
        if (so === null) { console.log('ShowOn error', field); continue;}

        let parts = so.split(':');
        let requiredField = document.getElementById('mainline_'+parts[0]);

        if (!requiredField) { console.log('ShowOn error', parts); continue;}

        if (!requiredField.hasOwnProperty('activator')) {
            requiredField.activator = [];
        }
        requiredField.activator.push({
            field: field,
            value: parts[1]
        });

        requiredField.addEventListener('change', checkShowOn );
        checkField(requiredField);
    }

}

function checkShowOn(e) {
    checkField(e.target);
}

function checkField(field) {

    if (!field.hasOwnProperty('activator')) {
        console.log('Error in showon', field);
        return;
    }

    for (let i=0; i < field.activator.length; i++) {
        let showon = field.activator[i];

        if (showon.value == field.value) {
            showon.field.classList.add('showed');
        } else {
            showon.field.classList.remove('showed');
        }
    }
}